import PropTypes from 'prop-types';

const buttonTypes = {
  /**
   * Button colors for emphasis
   */
  color: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'tertiary',
    'transparent',
  ]),
  /**
   * Button size/layout variants
   */
  variant: PropTypes.oneOf(['default', 'small']),
};

export default buttonTypes;
